import { InputNumberDesignTokens } from '@primeuix/themes/aura/inputnumber';

export const inputNumberTokens: InputNumberDesignTokens = {
  root: {
    transitionDuration: '{transition.duration}',
  },
  button: {
    width: '2.5rem',
    borderRadius: '{form.field.border.radius}',
    verticalPadding: '{form.field.padding.y}',
  },
  colorScheme: {
    light: {
      button: {
        background: 'transparent',
        hoverBackground: '{primary.50}',
        hoverBorderColor: '{form.field.border.color}',
        hoverColor: '{primary.600}',
        activeBackground: '{primary.50}',
        activeBorderColor: '{form.field.border.color}',
        activeColor: '{primary.700}',
        borderColor: '{form.field.border.color}',
        color: '{primary.500}',
      },
    },
    dark: {
      button: {
        background: 'transparent',
        hoverBackground: '{primary.900}',
        hoverBorderColor: '{form.field.border.color}',
        hoverColor: '{primary.300}',
        activeBackground: '{primary.800}',
        activeBorderColor: '{form.field.border.color}',
        activeColor: '{primary.300}',
        borderColor: '{form.field.border.color}',
        color: '{primary.300}',
      },
    },
  },
};
